var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAppleLogo = function SvgAppleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 12.192a4.989 4.989 0 0 1 2.357-4.152 5.128 5.128 0 0 0-3.99-2.157c-1.68-.177-3.308 1.005-4.164 1.005-.872 0-2.19-.988-3.608-.959a5.359 5.359 0 0 0-4.473 2.728c-1.934 3.349-.492 8.27 1.361 10.976.927 1.326 2.01 2.806 3.428 2.754 1.387-.058 1.905-.885 3.58-.885 1.658 0 2.144.885 3.59.851 1.489-.024 2.426-1.331 3.32-2.669a10.963 10.963 0 0 0 1.52-3.092 4.825 4.825 0 0 1-2.92-4.4ZM12.17 4.103a4.873 4.873 0 0 0 1.114-3.49 4.958 4.958 0 0 0-3.208 1.659 4.678 4.678 0 0 0-1.144 3.361 4.147 4.147 0 0 0 3.237-1.53Z",
    fill: "#FCFCFC"
  })));
};
export default SvgAppleLogo;